var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScenario2Intro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 34,
    viewBox: "0 0 41 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M40.0172 1.99985C40.5694 1.99036 41.0093 1.53502 40.9999 0.982815C40.9904 0.430612 40.535 -0.00934327 39.9828 0.000147641L40.0172 1.99985ZM7.29289 33.7071C7.68342 34.0976 8.31658 34.0976 8.70711 33.7071L15.0711 27.3431C15.4616 26.9526 15.4616 26.3195 15.0711 25.9289C14.6805 25.5384 14.0474 25.5384 13.6569 25.9289L8 31.5858L2.34315 25.9289C1.95262 25.5384 1.31946 25.5384 0.928932 25.9289C0.538408 26.3195 0.538408 26.9526 0.928932 27.3431L7.29289 33.7071ZM39.9828 0.000147641C25.3168 0.252217 16.9355 3.7835 12.2974 9.82879C7.70574 15.8135 7 24.0137 7 33H9C9 23.9863 9.74863 16.4365 13.8842 11.0462C17.9733 5.7165 25.592 2.24778 40.0172 1.99985L39.9828 0.000147641Z",
    fill: "#FFBE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario2Intro);
export default __webpack_public_path__ + "static/media/Scenario2Intro.1cf53f63dc66f3bcade85b0df8598b2c.svg";
export { ForwardRef as ReactComponent };